import { z } from 'zod'

/**
 * `portal.ai_summaries.payload` para `summary_type = 'sprint_progress'`.
 * Gerado pelo ERP via Edge Function, editado pelo time antes de publicar.
 */
const demandSchema = z.object({
  title: z.string(),
  description: z.string(),
  why: z.string(),
  result: z.string(),
})

const translatedTaskSchema = z.object({
  original: z.string(),
  translated: z.string(),
})

export const sprintProgressPayloadSchema = z.object({
  sprint_title: z.string(),
  initiative_context: z.string(),
  demands: z.array(demandSchema),
  tasks_summary: z.array(translatedTaskSchema).optional().default([]),
})

export type SprintProgressPayload = z.infer<typeof sprintProgressPayloadSchema>
export type Demand = z.infer<typeof demandSchema>

export function parseSprintProgressPayload(input: unknown): SprintProgressPayload {
  return sprintProgressPayloadSchema.parse(input)
}
